export * from './lib/LotteryDetails';
